import { measure } from "rot-js/lib/text";

const MAX_LOG_SIZE = 200;
let logs: string[] = [];
export function clearLog() {
  logs = [];
}

export function log(msg: string) {
  if (logs.length === MAX_LOG_SIZE) {
    logs.unshift();
  }
  logs.push(msg);
}

export function getLog() {
  return logs;
}

export function getLogSize() {
  return logs.length;
}

export function lineCount(msg: string, width: number) {
  return measure(msg, width).height;
}
